import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, Text } from "@mantine/core";
import { AppModal } from "../../shared/AppModal";
import { useDeletePriorityViewMutation } from "../../graphql/graphql";
import { showErrorNotification } from "../../shared/Notifications";
export const DeletePriorityViewModal = ({ priorityView, opened, close }) => {
    const [{ fetching }, deletePriorityView] = useDeletePriorityViewMutation();
    const handleDelete = async () => {
        try {
            await deletePriorityView({
                priorityViewId: priorityView.priorityViewId
            });
            handleClose();
        }
        catch (error) {
            console.error("An error occurred while deleting the priority view.", error);
            showErrorNotification();
        }
    };
    const handleClose = () => {
        close();
    };
    return (_jsxs(AppModal, { title: `Delete ${priorityView.name}?`, size: "md", opened: opened, onClose: handleClose, children: [_jsx(Text, { variant: "body-strong", children: `Are you sure you want to delete this pipeline view’?` }), _jsxs(Flex, { variant: "dialog-actions", gap: "md", children: [_jsx(Button, { variant: "outline", color: "gray", onClick: (event) => {
                            event.stopPropagation();
                            handleClose();
                        }, children: "Cancel" }), _jsx(Button, { variant: "filled", color: "var(--mantine-color-red-5)", loading: fetching, onClick: handleDelete, children: "Delete" })] })] }));
};
